import React from 'react';
import './HouseBanner.scss';

const HouseBanner = (props) => {
const { houseNumber, imageUrl } = props;

  return (
    <div
      className='house-banner'
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      <div className='overlay' />
      <h1 className='house-banner__title'>House Of Arie {houseNumber}</h1>
    </div>
  );
};

export default HouseBanner;
